<template>
	<div class="row margin-tb-150" dusk="success">

		<article class="wrap--sm">

			<section class="row">

				<header class="confirm margin-b-25 center">

					<h3>Betalingen blev gennemført</h3>

					<p>Mange tak for din bestilling. Vi sender inden længe en ordrebekræftelse til dig pr. e-mail som indeholder
						din ordre. Du kan også downloade din ordrebekræftelse nedenfor som PDF.</p>

				</header>

				<section class="row margin-b-50 center">

					<a class="btn--primary" :href="pdf" target="_blank">Download ordrebekræftelse</a>

				</section>

				<section class="row margin-b-50 center">

					<h3>Guide til tilberedning</h3>

					<p>Se vores guide til tilberedning af alle vores retter her: <br><a href="https://wiki.naesbyhovedskov.dk/" target="_blank">Se vores guide til tilberedning</a></p>

				</section>

			</section>

		</article>

	</div>
</template>

<script>
	import {mapGetters} from 'vuex';
    import totalCalculation from './../../mixins/customTotalCalculation';
	import moment from 'moment';
    export default {
        name: "completedOrder",
        mixins:[totalCalculation],
		computed:{
			...mapGetters({
                order:'order',
                product:'product',
                packaging_fee:'packaging_fee',
                energy_fee:'energy_fee',
		  	 }),
			pdf(){
				return this.order.invoiceLink;
			},
        },
        mounted(){
           setTimeout(()=>{
               const dataForDataLayer = {
                event: 'purchase',
                    transaction_id: this.order.order_uuid,
                    value: this.stripeAmount(this.total).amountForEditing,
                    currency: 'DKK',
                    shipping: this.stripeAmount(this.order.delivery.delivery_fee).amountForEditing, 
                    items: [
                        {
                            item_id: this.order.order_uuid,
                            item_name: this.product.title,
                            price: this.stripeAmount(this.total).amountForEditing / this.order.details.quantity,
                            quantity: this.order.details.quantity,

                        }
                    ]
                //    event: 'orderCompleted',
                //    order: {
                //        currency: 'DKK',
                //        total: this.stripeAmount(this.total).amountForEditing,
                //        deliveryFee: this.stripeAmount(this.order.delivery.delivery_fee).amountForEditing,
                //        productName: this.product.title,
                //        productCategory: this.product.category_title,
                //        quantity: this.order.details.quantity,
                //        orderUuid: this.order.order_uuid
                //    },
                //    transactionId: this.order.order_uuid,
                //    transactionTotal: this.stripeAmount(this.total).amountForEditing,
                //    transactionShipping: this.stripeAmount(this.order.delivery.delivery_fee).amountForEditing,
                //    transactionProducts: [{
                //        'sku': this.order.order_uuid,
                //        'name': this.product.title,
                //        'category': this.product.category_title,
                //        'price': this.stripeAmount(this.total).amountForEditing / this.order.details.quantity,
                //        'quantity': this.order.details.quantity
                //    }]

               };
               console.log(dataForDataLayer);
               dataLayer.push(dataForDataLayer);

           }, 200);
        }
    }
</script>

<style scoped>

</style>
